/* Provencelia, 29/09/2026 : barre « Ajouter au panier » flottante sur mobile (fiche produit).
   Apparaît dès que le bouton principal est sorti de l'écran vers le haut, disparaît quand on
   remonte. Vignette, nom et prix à gauche ; le bouton déclenche le vrai bouton de la fiche
   (même formulaire, même quantité, même pop-up panier). Données : snippets/pv-stock
   ([data-pv-barre]). Styles : assets/pv-complements.css (.pv-barre). Sous 700 px uniquement. */
(function () {
  'use strict';

  function lancer() {
    var source = document.querySelector('[data-pv-barre]');
    var bouton = document.querySelector('.quantity_selector__custom--buy-buttons button[type="submit"]');
    if (!source || !bouton || bouton.disabled || document.querySelector('.pv-barre')) return;

    var barre = document.createElement('div');
    barre.className = 'pv-barre';
    barre.setAttribute('aria-hidden', 'true');
    barre.innerHTML =
      (source.dataset.image ? '<img class="pv-barre__image" alt="" src="' + source.dataset.image + '">' : '') +
      '<div class="pv-barre__infos"><span class="pv-barre__nom"></span><span class="pv-barre__prix"></span></div>' +
      '<button type="button" class="pv-barre__bouton"></button>';
    barre.querySelector('.pv-barre__nom').textContent = source.dataset.titre || '';
    barre.querySelector('.pv-barre__prix').textContent = source.dataset.prix || '';
    barre.querySelector('.pv-barre__bouton').textContent = (bouton.textContent || '').trim();
    document.body.appendChild(barre);

    barre.querySelector('.pv-barre__bouton').addEventListener('click', function () {
      bouton.click();
    });

    var montrer = function (oui) {
      barre.classList.toggle('is-visible', oui);
      barre.setAttribute('aria-hidden', oui ? 'false' : 'true');
    };

    new IntersectionObserver(function (entrees) {
      var e = entrees[0];
      montrer(!e.isIntersecting && e.boundingClientRect.bottom < 0);
    }).observe(bouton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lancer);
  } else {
    lancer();
  }
})();
